import { ApolloError, FetchResult } from '@apollo/client';

export default async function requestHandler<T>(fn: Promise<FetchResult<T>>) {
  let data;
  let error: string | undefined;
  try {
    const { data: response } = await fn;

    data = response;
  } catch (err) {
    console.error({ err });
    error = (err as ApolloError).message;
  }

  return { data, error };
}
